import React from "react";
import { CellData } from "./table";
import { TableCell } from "./tableCell/tableCell";

interface TableBodyProps {
  computedCellData: CellData[][];
  tableDataToRender: any[];
  tableWidth: number;
  onRowClick: (tableData: any[], rowIndex: number, className: string) => void;
  onAssignToClick?: (data: any) => void;
  onStatusClick?: (data: any) => void;
  onDeleteIconClick?: (data: any) => void;
  onClickableTextWithDisabledStatusClick?: (data: any) => void;
  onComplete?: () => void;
  toggleCheckboxSelection?: (id: string) => void;
  handleDownloadButtonClick?: (id: string) => void;
  onValueChange?: (value: string) => void;
  onTableRowUpdate?: (
    rowIndex: number,
    fieldKey: string,
    newValue: any,
  ) => void;
  startIndex?: number;
  onSideModalClose?: () => void;
  onChangeEmit?: (data: {
    name: string;
    required: boolean;
    value: boolean;
  }) => void;
  onPropagateEventOnClickInRpaStatusCell?: (id: string) => void;
  onPropagateEventOnClickInRpaStatusTwoCell?: (id: string) => void;
  onValueChangeOfTextField?: (value: string, id: string) => void;
  rowClassName?: string | ((rowData: any, rowIndex: number) => string);
}

const TableBody: React.FC<TableBodyProps> = ({
  computedCellData,
  tableDataToRender,
  tableWidth,
  onRowClick,
  onAssignToClick,
  onStatusClick,
  onDeleteIconClick,
  onClickableTextWithDisabledStatusClick,
  onComplete,
  toggleCheckboxSelection,
  handleDownloadButtonClick,
  onTableRowUpdate,
  onValueChange,
  startIndex,
  onSideModalClose,
  onChangeEmit,
  onPropagateEventOnClickInRpaStatusCell,
  onPropagateEventOnClickInRpaStatusTwoCell,
  onValueChangeOfTextField,
  rowClassName,
}) => {
  const handleTableRowUpdate = (
    rowIndex: number,
    fieldKey: string,
    newValue: any,
  ) => {
    onTableRowUpdate?.(rowIndex, fieldKey, newValue);
  };

  const handleValueChange = (value: string) => {};

  return (
    <tbody>
      {computedCellData.map((rowData, rowIndex) => {
        const currentRow = rowData[0]?.rowData;
        const extraRowClass =
          typeof rowClassName === "function"
            ? rowClassName(currentRow, rowIndex)
            : (rowClassName ?? "");
        return (
          <tr
            key={rowIndex}
            style={{ display: "flex", width: "100%" }}
            className={extraRowClass}
          >
            {rowData.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                className={`table-cell ${cell.type}__${cell.header}`}
                style={{
                  width: `${cell?.width}%`,
                }}
                onClick={() =>
                  onRowClick(
                    tableDataToRender,
                    rowIndex,
                    `table-cell ${cell.type}__${cell.header}`,
                  )
                }
              >
                <TableCell
                  type={cell.type}
                  id={cell.rowData?.id}
                  value={cell.value}
                  header={cell.header}
                  rowIndex={rowIndex}
                  globalRowIndex={startIndex ? startIndex + rowIndex : rowIndex}
                  rowData={cell.rowData}
                  handleAssignToClick={onAssignToClick}
                  handleStatusClick={onStatusClick}
                  handleDeleteIconClick={onDeleteIconClick}
                  handleClickableTextWithDisabledStatusClick={
                    onClickableTextWithDisabledStatusClick
                  }
                  onComplete={onComplete}
                  toggleCheckboxSelection={toggleCheckboxSelection}
                  handleDownloadButtonClick={handleDownloadButtonClick}
                  onTableRowUpdate={handleTableRowUpdate}
                  onValueChange={handleValueChange}
                  onSideModalClose={onSideModalClose}
                  onChangeEmit={onChangeEmit}
                  onPropagateEventOnClickInRpaStatusCell={
                    onPropagateEventOnClickInRpaStatusCell
                  }
                  onPropagateEventOnClickInRpaStatusTwoCell={
                    onPropagateEventOnClickInRpaStatusTwoCell
                  }
                  onValueChangeOfTextField={onValueChangeOfTextField}
                />
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TableBody;
